import { DeliveryPreviewResponse } from 'src/api/getDeliveryPreview';

export const createClipboardData = ({
  uuid,
  responseURI,
  ref,
  deliveryPreview
}: {
  uuid: UUID;
  responseURI?: string;
  ref?: string;
  deliveryPreview?: DeliveryPreviewResponse;
}): string => {
  let clipboardData = '';

  if (uuid) {
    clipboardData = 'uuid=' + uuid;
  }

  if (responseURI) {
    clipboardData = clipboardData + ';responseURI=' + responseURI;
  }

  if (deliveryPreview?.deliveryID) {
    clipboardData = clipboardData + ';delivery_id=' + deliveryPreview.deliveryID;
  }

  if (ref) {
    clipboardData = clipboardData + ';ref=' + ref;
  }

  //TODO: [mr] trackID

  return clipboardData;
};
